module.exports = __webpack_public_path__ + "img/codecious.3de9b0bf.png";